import axiosInstance from 'api/axios';
import { APIResponse } from '../types';

const publishService = {
  // for publishing posts immediately
  publishBlog: async (blogId: number): Promise<APIResponse<string>> => {
    const response = await axiosInstance.private.post(
      '/api/v1/linkedin/blogs/publish',
      { blog_id: blogId }
    );
    return response.data;
  },
};

export default publishService;
